<div class="comparison-doc-card">
  <h2>Comparison Instructions</h2>
  <section id="overview" class="quotes-doc-section">
    <p>The Comparison page allows you to analyze and compare different models or items side by side. Use the features below to filter, select, and review detailed differences efficiently.</p>
    <ul class="quick-nav-list">
      <li><a (click)="scrollToSection('card-select')">Card Select</a></li>
      <li><a (click)="scrollToSection('selection')">Selection</a></li>
      <li><a (click)="scrollToSection('selected-models')">Selected Models</a></li>
      <li><a (click)="scrollToSection('filter')">Filter</a></li>
      <li><a (click)="scrollToSection('download-file')">Download File</a></li>
    </ul>
  </section>

  <section id="card-select" class="quotes-doc-section">
    <h3>Card Select</h3>
    <div class="create-quote-card">
      <div class="doc-flex-row">
        <img src="assets/img/documentation-img/comparison-card-select.png" alt="Comparison Card Select" class="doc-image">
        <div class="button-descriptions">
          <ul>
            <li><strong>Select Cards:</strong> Click on cards to select the models you want to compare. Selected cards will be highlighted for clarity.</li>
            <li><strong>Navigation:</strong> You can also switch between different types and choose different models to compare.</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section id="selection" class="quotes-doc-section">
    <h3>Selection</h3>
    <div class="create-quote-card">
      <div class="doc-flex-row">
        <img src="assets/img/documentation-img/comparison-selection.png" alt="Comparison Selection" class="doc-image-selection">
        <div class="button-descriptions">
          <ul>
            <li><strong>Selection:</strong> Click on the checkbox next to the model name you want to add to the comparison. You need to select at least 2 models to compare.</li>
            <li><strong>Search:</strong> Also, for convenience, use the . Enter keywords or the beginning of the model name. This will help speed up the search.</li>
          </ul>
        </div>
      </div>
      <div class="important-note">
        <strong>Important:</strong> To compare, you need to select at least 2 models. The maximum number of selected models is 10.
      </div>
    </div>
  </section>

  <section id="selected-models" class="quotes-doc-section">
    <h3>Selected Models</h3>
    <div class="create-quote-card">
      <div class="doc-flex-row">
        <img src="assets/img/documentation-img/comparison-selected-models.png" alt="Comparison Selected Models" class="doc-image">
        <div class="button-descriptions">
          <ul>
            <li><strong>Model Overview:</strong> In the sidebar, review which models you have added to the comparison and click the "Compare" button to proceed to the comparison.</li>
            <li><strong>Remove Models:</strong> Click the clear button to deselect a model from the comparison.</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section id="filter" class="quotes-doc-section">
    <h3>Filter</h3>
    <p>When you go to the comparison you will see a table with the comparison. You can manage it using the filter.</p>
    <div class="create-quote-card">
      <div class="doc-flex-row">
        <img src="assets/img/documentation-img/comparison-filter.png" alt="Comparison Filter" class="doc-image-filter">
        <div class="button-descriptions">
          <ul>
            <li><strong>Hide:</strong> To hide the sidebar with filters, tap the filter icon. Tap it again to expand the filters.</li>
            <li><strong>Filter by Comparison Result:</strong> You can sort what you want to see in your table. By default you will see all positions in the table. But using the dropdown you can select match and mismatch positions.</li>
            <li><strong>Filter by Category:</strong> Using the checkboxes, you can select the categories you want to display in the comparison table.</li>
          </ul>
        </div>
      </div>
    </div>
  </section>



  <section id="download-file" class="quotes-doc-section">
    <h3>Download File</h3>
    <div class="create-quote-card">
      <div class="doc-flex-row">
        <img src="assets/img/documentation-img/comparison-download-file.png" alt="Comparison Download File" class="doc-image-filter">
        <div class="button-descriptions">
          <ul>
            <li><strong>Export Comparison:</strong> Download the results of your comparison as a file for offline review or sharing.</li>
            <li><strong>Supported Formats:</strong> Choose from available formats such as PDF or Excel, depending on your needs.</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</div>
